import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { AdminBookingInfo, AdminBookingInfoWithStartEndAndLocation } from '../../../../models/api/AdminBookingInfo';
import { TherapistModel } from '../../../../models/api/TherapistModel';
import { UtcToLocalPipe } from '../../../../pipes/utc-to-local.pipe';
import { BookingService } from '../../../../services/api/BookingService';
import { TherapistService } from '../../../../services/api/TherapistService';
import { EventService } from '../../../../services/api/EventService';
import { EventModel } from '../../../../models/api/EventModel';
import { forkJoin, interval, startWith, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-event-bookings',
  standalone: true,
  imports: [MatTableModule, RouterModule, MatIconModule, MatSortModule, MatTooltipModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatSelectModule, DatePipe, UtcToLocalPipe],
  templateUrl: './event-bookings.component.html',
  styleUrl: './event-bookings.component.scss'
})
export class EventBookingsComponent implements OnDestroy, OnInit {
  bookings: AdminBookingInfoWithStartEndAndLocation[] = [];
  bookingsTemp: AdminBookingInfo[] = [];
  bookingStatus: number = 0;
  therapists: TherapistModel[] = [];
  public eventID: number = 0;
  public isLoaded: boolean = false;
  public eventDetail: EventModel = new EventModel;

  constructor(private router: Router,
    private bookingService: BookingService,
    private route: ActivatedRoute,
    private eventService: EventService,
    private therapistService: TherapistService) {
    this.eventID = Number(this.route.snapshot.paramMap.get('id'));
    const navigation = this.router.getCurrentNavigation();
    this.bookingStatus = navigation?.extras?.state?.['bookingStatus'];
  }

  displayedColumns: string[] = ['bookingId', 'fullName', 'queuePos', 'massageLength', 'mobileNumber', 'bookingStatusID', 'bookingDate', 'requestedTherapistID', 'assignedTherapistID', 'actions'];
  dataSource = new MatTableDataSource<AdminBookingInfo>();

  @ViewChild(MatSort) sort!: MatSort;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    interval(10000)
      .pipe(
        startWith(0),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.loadData();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadData(): void {
    forkJoin({
      eventDetail: this.eventService.getEvent(this.eventID),
      bookings: this.bookingService.getAdminBookingListByEvent(this.eventID),
      therapistsResponse: this.therapistService.findTherapist()
    }).subscribe({
      next: ({ eventDetail, bookings, therapistsResponse }) => {
        this.eventDetail = eventDetail;

        this.bookings = bookings;

        this.bookingsTemp = this.bookings;
        this.dataSource.data = this.bookingsTemp;
        this.dataSource.sort = this.sort;

        if (this.bookingStatus > 0) {
          this.filterTable(this.bookingStatus);
        }

        this.therapists = therapistsResponse.data as TherapistModel[];
        this.isLoaded = true;
      },
      error: (err) => console.error(err)
    });
  }

  deleteBooking(bookingID: number) {

    const confirmed = confirm('Are you sure you want to delete this booking?');
    if (confirmed) {
      this.bookingService.deleteBooking(bookingID).subscribe(() => {
        alert('Booking deleted successfully');
      });
    }
  }
  resetBooking(bookingID: number) {
    const reset = confirm('Are you sure you want to reset this booking?');
    if (reset) {
      this.bookingService.bookingReset(bookingID).subscribe(() => {
        alert('Booking reset successfully');
        this.bookingService.getAdminBookingList().subscribe(data => {
          this.bookings = data;
          this.bookingsTemp = this.bookings;
          this.dataSource.data = this.bookingsTemp;
        });
      });
    }
  }


  cancelBooking(bookingID: number) {
    const cancel = confirm('Are you sure you want to cancel this booking?');
    if (cancel) {
      this.bookingService.adminCancelBooking(bookingID).subscribe({
        next: (data) => {
          alert('Booking cancelled successfully');
          this.bookingService.getAdminBookingList().subscribe(data => {
            this.bookings = data;
            this.bookingsTemp = this.bookings;
            this.dataSource.data = this.bookingsTemp;
          });

        },
        error: (err) => {

        }
      })
    }
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  filterTable(value: number) {
    this.bookingsTemp = this.bookings;

    if (value > 0) {
      this.bookingsTemp = this.bookingsTemp.filter(t => t.bookingStatusID === value);

    }

    this.dataSource.data = this.bookingsTemp;

  }

  getTherapistName(therapistID: number) {

    const therapist = this.therapists.find(x => x.therapistID === therapistID);
    return therapist?.firstName + ' ' + therapist?.lastName;
  }

  bookingsStatusTypeLookup: { [key: number]: string } = {
    1: 'Draft',
    2: 'Booked',
    3: 'Assigned',
    4: 'Accepted',
    5: 'In Progress',
    6: 'Completed',
    7: 'Cancelled',
    8: 'Declined',
    9: 'Did Not Happen',
  };

}
